import React from 'react';
import Modal from '../../shared/modal';
import ActivitiesTable from './ActivitiesTable';


interface IActivitesModal {
    openModal: boolean;
    handleCloseModal: () => void;
}

const ActivitesModal = ({
    openModal,
    handleCloseModal,
}: IActivitesModal) => {

    const onCloseModal = () => {
        handleCloseModal();
    }

    return (
        <Modal
            open={openModal}
            onClose={onCloseModal}
            contentContainerStyle={'!rounded-xl min-w-[95%] md:min-w-[70%] lg:min-w-[60%]'}>
            <div className={'p-2 min-w-[95%] md:min-w-[70%] lg:min-w-[60%] min-h-[500px] '}>
                <p className='mb-2 font-semibold text-sm dark:text-primary-dark'>Activites</p>
                <div>
                    <ActivitiesTable />
                </div>
            </div>
        </Modal >
    )
}
export default ActivitesModal;